import styled from "@emotion/styled";

import { sizeToken } from "../../Internals/ThemeProvider/CandyTheme/ThemeBuilder/ICandyTheme";

export const UnitListRoot = styled.ul({
    flex: "1 1 100%",
    listStyle: "none",
    margin: 0,
    padding: sizeToken(1),
});
